
import { Component } from 'react';

import ContentDropdown from './grants-dropdown';
import Card from '../../../components/grants/card';
import {ManageButton, ViewButton} from "../../../components/buttons";
import {stringToFriendlyDatetime} from "../../../lib/helpers/datetime-helpers";

import ButtonPrevious from '../../../components/buttons-navigation/button-previous';
import ButtonNext from '../../../components/buttons-navigation/button-next';

import MediaQuery from 'react-responsive';

import Sponsors from '../../../components/sponsor';

export default class GrantsApplications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedApplication: 0,
            width: window.innerWidth,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    returnXItems(arr, amount) {
        return arr.filter((_, index) => index + 1 <= amount);
    }

    next() {
        this.setState({ selectedApplication: this.state.selectedApplication - 1 });
    }

    previous() {
        this.setState({ selectedApplication: this.state.selectedApplication + 1 });
    }

    handleTypes(app) {
        const status = app.status;

        switch (status) {
            case ('rejected') :
            case ('offer rejected') :
                return 'declined';
            case ('approved') :
            case ('offer letter sent') :
            case ('offer accepted') :
            case ('documents received') :
            case ('claim approved for payment') :
            case ('claim submitted for payment') :
            case ('claim processed') :
            case ('completed') :
                return 'accepted';
            default :
                return 'awaiting';
        }
    }

    handleStatus(app) {
        const status = app.status;
        switch (status) {
            case ('pending') :
                return 'Application Submitted for Review';
            case ('scoring') :
                return 'Application Submitted for Review';
            case ('approved') :
                return 'Application Accepted';
            case ('rejected') :
                return 'Application Rejected';
            case ('offer letter sent') :
                return 'Application Accepted: Offer Letter Sent';
            case ('offer accepted') :
                return 'Application Accepted: Offer Accepted';
            case ('offer rejected') :
                return  'Application Rejected: Offer Rejected';
            case ('documents requested') :
                return 'Application Accepted: Grant Documents Requested';
            case ('documents received') :
                return 'Application Accepted: Grant Documents Received';
            case ('claim approved for payment') :
                return 'Application Accepted: Claim Approved for Payment';
            case ('claim submitted for payment') :
                return 'Application Accepted: Claim Submitted for Payment';
            case ('claim processed') :
                return 'Application Accepted: Claim processed';
            case ('completed') :
                return  'Application Accepted: Completed';
            default :
                return app.status;
        }
    }
    renderApplications() {
        return this.props.applications.map(app => {
                return <Card
                    title={app.grant.name}
                    type={this.handleTypes(app)}
                    status={this.handleStatus(app)}
                    onClick={() => {
                        window.location.href = `/myeb/grants/applications/${app.id}`
                    }}
                    subtitle={app.name !== null ? `#${app.name.toUpperCase()}` : ''}
                    infos={[
                        {
                            label : 'LAST UPDATED',
                            value : stringToFriendlyDatetime(app.updated_at)
                        },
                        {
                            label : 'CLOSES',
                            value : stringToFriendlyDatetime(app.grant.available_to)
                        }
                    ]}
                    buttons={
                        <>
                            <ManageButton responsive={false} onClick={() => window.location.href = `/myeb/grants/applications/${app.id}`}/>
                        </>
                    }

                />
            });
    }

    renderContainer(translate) {
        const getNumItems = () => {
            return this.state.width <= 685 ? 1 : 2;
        }

        const max = this.state.selectedApplication - getNumItems();

        console.log(-max, this.props.applications.length);

        return (
            <>
                <div className="grants-list__inner" style={{ transform: `translateX(${this.state.selectedApplication * translate}%)` }}>
                    { this.renderApplications() }
                </div>
            </>
        )
    }

    renderCarouselButton() {
        const getNumItems = () => {
            return this.state.width <= 685 ? 1 : 2;
        }

        const max = this.state.selectedApplication - getNumItems();

        return (
            <div className="grants-list__buttons">
                { this.state.selectedApplication !== 0 && <ButtonPrevious onClick={this.previous.bind(this)}>Previous</ButtonPrevious> }
                { (-max < this.props.applications.length) && <ButtonNext onClick={this.next.bind(this)}>Next</ButtonNext> }
            </div>
        )
    }

    render() {
        const app = this.props.applications[this.state.selectedApplication];

        return (
            <div className='grants-list'>
                {/*<p className="section__title"><img src="/assets/logos/open-applications.svg"/> Open Applications</p>*/}

                { this.props.applications.length > 0 ?
                    <div className="grants-list__content">
                        <MediaQuery minWidth="0px" maxWidth="685px">
                            { this.renderContainer(100) }
                        </MediaQuery>

                        <MediaQuery minWidth="686px" maxWidth="1279px">
                            { this.renderContainer(50) }
                        </MediaQuery>

                        <MediaQuery minWidth='1280px'>
                            <div className="grants-list__inner">
                                { this.renderApplications() }
                            </div>
                        </MediaQuery>
                    </div> :
                    <div style={{  width: '100%', height: '20vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{  fontSize: '14px', color: '#61707F' }}>No applications are currently open. Get started by heading to 'Grants' in the Menu</p>
                    </div>
                }

                <MediaQuery minWidth='0px' maxWidth='685px'>
                    { this.renderCarouselButton() }
                </MediaQuery>
                <MediaQuery minWidth="686px" maxWidth="1279px">
                    { this.renderCarouselButton() }
                </MediaQuery>
                <MediaQuery minWidth="1280px">
                    <Sponsors />
                </MediaQuery>

            </div>
        )
    }
}
